import { Link } from "react-router-dom";
import { ConstantImport } from "../../Constants/ConstantImport";
import { ISPGWaitlist } from "./IsPGWaitlist";
import { IsRetHOMEFees } from "./IsRetHOMEFees";
import { IsRetOSUG } from "./IsRetOSUG";
import { IsRetSouthend } from "./IsRetSouthend";
import { IsRetStudyAbroad } from "./IsRetStudyAbroad";
import { IsUGWaitlist } from "./IsUGWaitlist";
import { IsSummer } from "./IsSummer";
import { AdminAccess } from "../AdminAccess";

export interface IntroductionProps {
    EventID?: string;
    Campus: string;
    AcadYearLabel: string;
    StudentGUID: string | undefined;
    SiteAdmins: Array<String> | undefined;
}

export default function Introduction(props: IntroductionProps) {
    var retelem: JSX.Element;

    switch (props.EventID) {
        case null:
            retelem = <fieldset className="GatewayError">You're not currently eligible to apply for accommodation and shouldn't be able to see this page.</fieldset>;
            break;
        case "SUMMER":
            retelem = <IsSummer Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsSummer>;
            break;
        case "UGWLIST":
            retelem = <IsUGWaitlist Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsUGWaitlist>;
            break;
        case "PGWLIST":
            retelem = <ISPGWaitlist Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></ISPGWaitlist>;
            break;
        case "RETSOALL":
            retelem = <IsRetSouthend Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsRetSouthend>;
            break;
        case "RETOSUGS":
            retelem = <IsRetOSUG Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsRetOSUG>;
            break;
        case "RETSTUDYAB":
            retelem = <IsRetStudyAbroad Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsRetStudyAbroad>;
            break;
        case "UGWLISTSO":
            retelem = <IsUGWaitlist Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsUGWaitlist>;
            break;
        case "PGWLISTSO":
            retelem = <ISPGWaitlist Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></ISPGWaitlist>;
            break;
        case "UGBALLOTFINAL":
            retelem = <IsRetHOMEFees Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsRetHOMEFees>;
            break;
        case "UGBALLOTOTHER":
            retelem = <IsRetHOMEFees Campus={props.Campus} AcadYearLabel={props.AcadYearLabel}></IsRetHOMEFees>;
            break;
        default:
            retelem = <AdminAccess SiteAdmins={props.SiteAdmins} DeniedMessage={<div className="GatewayError">Something unreachable has happened.</div>}>
                <div className="GatewayError">Recieved an EventID of [{props.EventID}] and couldn't parse it.</div>
            </AdminAccess>;
            break;
    }

    return <div className="Contents">
        {retelem}

        {
            /* ternary 
            if StudentGUID is defined - ie not (undefined in case it's uninitialised, null in case it came back dbnull):
            - show link button
            - otherwise, show inert error 'button' placeholder.
            */
            (props.StudentGUID !== undefined && props.StudentGUID !== null)
                ?
                <p>
                    <Link className="LinkButton" to={ConstantImport.KXLinkURL + props.StudentGUID.toLowerCase()}>
                        Proceed to Accommodation Application System
                    </Link>
                </p>
                :
                <div className="GatewayError">
                    KX user ident not found.
                </div>
        }

        <p>
            <Link className="LinkButton" to="/">Back</Link>
        </p>
    </div>;
}